import type { ReactNode } from 'react';

import { ChartNoAxesCombinedIcon, LightbulbIcon, type LucideIcon } from 'lucide-react';

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

type AnalyticsEmptyStateIcon = 'chart' | 'lightbulb';

const ICON_COMPONENTS: Record<AnalyticsEmptyStateIcon, LucideIcon> = {
  chart: ChartNoAxesCombinedIcon,
  lightbulb: LightbulbIcon,
};

type AnalyticsEmptyStateProps = {
  title: string;
  description: string;
  icon?: AnalyticsEmptyStateIcon;
  action?: ReactNode;
  className?: string;
};

export const AnalyticsEmptyState = ({
  title,
  description,
  icon = 'chart',
  action,
  className,
}: AnalyticsEmptyStateProps) => {
  const Icon = ICON_COMPONENTS[icon];

  return (
    <Empty className={className} role="status" aria-live="polite">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Icon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      {action && <EmptyContent>{action}</EmptyContent>}
    </Empty>
  );
};
